module.exports = __webpack_public_path__ + "pc/img/vico.647d2d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rightNav/vico.jpg
// module id = Vl19
// module chunks = 3